<template>
  <div class="fillit bc-gray" v-show="kpi">
  <table class="kpitable">
      <tr>
        <td class="kpicol-small"
            v-bind:style="{ 'width': getMinorItemWidth(minorWaveCount) + '%', }"
            v-for="index in minorWaveCount"
            v-bind:class="getBackgroundClass(index)"
            v-bind:key="index">
          <div class="perf-cell">
            <div class="perf-block">
              <div class="perf-head" v-bind:class="{ narrow: isNarrow(index) }">{{ getSlotName(index) }}</div>
              <div class="perf-value">{{ getSlotValue(index) }}</div>
            </div>
          </div>
        </td>
       <td class="kpicol-large"
           v-bind:style="{ 'width': getMajorItemWidth(minorWaveCount) + '%', }"
            v-bind:class="getBackgroundClass(101)">
          <div class="container2">
            <div class="perf-head left" v-bind:class="{ narrow: isNarrow(101) }">{{ getSlotName(101) }}</div>
            <div class="bc-highlight">{{ getSlotValue(101) }}</div>
            <div class="image">
              <span href="#" style="color: black;" >
                <font-awesome-icon v-if="getArrow === 2" icon="arrow-up" item-width="24" item-height="36" />
                <font-awesome-icon v-if="getArrow === 3" icon="arrow-down" item-width="24" item-height="36" />
                <font-awesome-icon v-if="getArrow === 1" icon="arrow-right" item-width="24" item-height="36" />
              </span>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>

</template>

<script>

  const ArrowType = {
    NoChange: 1,
    Up: 2,
    Down: 3
  }

  export default {

    name: 'PerformanceItem',

    data () {
      return {
        ArrowType: ArrowType
      }
    },

    props:[
      'overallByWave',
      'monochrome',
      'kpi',
      'invertArrow'
    ],

    watch: {
      kpi: {
        immediate: true,
        handler(newVal, oldVal) {
          if (newVal == null || newVal.Tagged !== undefined) return
          if (!this.overallByWave || !this.overallByWave.Tagged) this.tagOverall(this.overallByWave)
          this.tagItem(newVal, this.overallByWave)
        },
      },
    },

    methods:{
      getOtherClass: function (slot){
        return '{ width: 25%; }';
      },
      tagItem(newVal, overall) {
        var i;
        for (i = 0; i < overall.SurveyWave.length; i++) {
            let over = overall.SurveyWave[i]
            let item = _.find(newVal.SurveyWave, ['Name', over.Name])
            if(item) item.Slot = over.Slot
        }
        newVal.Tagged = true
      },

      tagOverall(newVal) {
        let last = _.last(newVal.SurveyWave)
        last.Slot = 101

        let index = 0
        _.forEach(newVal.SurveyWave, function(value) {
          if (value.Name.length > 0 && !value.Slot && value !== last) {
            value.Slot = ++index
          }
        });

        newVal.Tagged = true
      },

      getBackgroundForIndicator: function (index) {
        if (this.monochrome) {
          return {'bc-gray' : true}
        }

        if (index === null) {
          return  {'bc-red' : true}
        }

        if (this.kpi === null || this.kpi.SurveyWave === null ) {
          return {'bc-gray' : true}
        }

        if (this.kpi.SurveyWave[index].Result === undefined) {
          return {'bc-gray' : true}
        }
        if (this.kpi.SurveyWave[index].Result < 60) {
          return { 'bc-red': true }
        }
        else if (this.kpi.SurveyWave[index].Result < 90) {
          return  {'bc-yellow' : true}
        }
        else {
          return  {'bc-green' : true}
        }
      },

      getBackgroundClass: function (slot){
        var _kpi = this.kpi
        if (!_kpi || !_kpi.SurveyWave || this.monochrome) return { 'bc-gray' : true }

        let it = this.getSlot(slot)
        if (!it || it.Result === undefined) return {'bc-gray' : true}

        if (it.Result < 60) return { 'bc-red': true }
        else if (it.Result < 90) return  {'bc-yellow' : true}
        else return {'bc-green' : true}
      },

      getArrowForItems: function (firstQuarter, nextQuarter) {
        if(!this.invertArrow) {
          if (firstQuarter.Result > nextQuarter.Result) return 3
          if (firstQuarter.Result < nextQuarter.Result) return 2
          return 1
        }

        if (firstQuarter.Result > nextQuarter.Result) return 2
        if (firstQuarter.Result < nextQuarter.Result) return 3
        return 1
      },

      getSlot: function(slot) {
        if (!this.kpi || !this.kpi.SurveyWave)
          return undefined
        return _.find(this.kpi.SurveyWave, ['Slot', slot])
      },

      getSlotName: function(slot) {
        let it = this.getSlot(slot)
        if (it === undefined || it.Result === undefined) return ''
        return it.Name
      },

      getSlotValue: function(slot) {
        let it = this.getSlot(slot)
        if (it === undefined || it.Result === undefined) return ''
        return it.Result
      },

      isNarrow: function(slot) {
        if (!this.kpi || !this.kpi.SurveyWave)
          return false

        let it = _.find(this.kpi.SurveyWave, ['Slot', slot])
        if (it === undefined || it.Result === undefined) {
          return false
        }
        return it.Name.length > 2
      },

      hasWaves() {
        return this.overallByWave && this.overallByWave.SurveyWave && _.size(this.overallByWave.SurveyWave) > 0
      },

      getMinorItemWidth(waves) {
        if (waves < 4) return 16.666
        return 72 / waves
      },

      getMajorItemWidth(waves) {
        if (waves < 4) return 50
        return 28
      }
    },

    computed: {
      waveCount: function () {
        if (!this.hasWaves()) return 4
        // Result must be equal or between 4 and 6
        return Math.max(4, Math.min(6, _.size(this.overallByWave.SurveyWave)));
      },

      minorWaveCount: function () {
        return this.waveCount - 1
      },

      getArrow: function() {
        if (!this.kpi || !this.kpi.SurveyWave || _.size(this.kpi.SurveyWave) < 2) {
          return 1
        }

        var arrSize = _.size(this.kpi.SurveyWave)
        return this.getArrowForItems(this.kpi.SurveyWave[arrSize - 2], this.kpi.SurveyWave[arrSize - 1])
      }
    }
  }

</script>

<style scoped>
  .fillit {
    width: 100%;
    overflow: hidden;
  }

  .kpitable {
    height: auto;
    width: 100%;
    float: right;
  }
  
  .narrow {
    letter-spacing: -0.125em;
    text-overflow: ellipsis;
  }

  .perf-cell {
    display: grid;
    text-overflow: clip;
    white-space: nowrap;
    margin: 0px;
    padding: 0px;
  }

  .perf-block {
    display: grid;
    height: 32px;
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0px;
    padding: 0px;
  }

  .perf-head {
    display: grid;
    position: relative;
    font-size: 9pt;
    font-stretch: ultra-condensed;
    font-weight: bold;
    top: 0px;
    width: 100%;
    text-align: center;
    overflow: hidden;
    margin: 0px;
    padding: 0px;
  }

  .perf-value {
    display: grid;
    position: relative;
    font-size: 9pt;
    width: 100%;

    text-align: center;
    height: 50%;
  }

  .image {
    position: relative;
    top: -30px;
    right: -36px;
    border: 0px;
    color: black;
  }

  .container2 {
    display: flex;
    margin: 0px;
    padding: 0px;
    display: inline-block;
    *display: inline;
    vertical-align: top;
    height: 32px;
  }

  .bc-highlight {
    position: relative;
    top: -6px;
    margin-top: -6px;
    margin-left: 9px;
    padding: 0px;
    top: 0%;
    font-stretch: extra-condensed;
    font-weight: bold;
  }

  .kpicol-small {
    width: 16.666%;
  }

  .kpicol-large {
    width: 50%;
  }
</style>
